import type { UserRow } from '../userViewModel';

import UserStatusPill from './UserStatusPill';

/** Whether the row is deactivated with an invite still outstanding. */
export function hasPendingInviteHint(user: Pick<UserRow, 'status' | 'provisioningStatus'>) {
  return user.status === 'inactive' && user.provisioningStatus === 'invited';
}

/** The status pill, plus an "Invite pending" hint when one applies. */
export default function UserStatusPills({ user }: { user: UserRow }) {
  return (
    <>
      <UserStatusPill status={user.status} />
      {hasPendingInviteHint(user) && <UserStatusPill status="invited" label="Invite pending" />}
    </>
  );
}
